import { FC } from "react";

const EmptyWrapper: FC<{ children?: any }> = ({ children }) => <>{children}</>;

export default EmptyWrapper;
